import { combineReducers } from '@reduxjs/toolkit';
import { createReducer } from 'typesafe-actions';

import {
    CauseEntity,
    CauseICDCodeEntity,
    CroEntity,
    LocationEntity,
    RaceEntity,
    ReiEntity,
    SequelaEntity,
} from '@portal/common/types';

import {
    getCauseIcdCodesAsync,
    getCausesAsync,
    getCrosAsync,
    getEtiologiesAsync,
    getImpairmentsAsync,
    getInjuryAsync,
    getLocationsAsync,
    getRacesAsync,
    getRisksAsync,
    getSequelasAsync,
    getVehssAsync,
} from './actions';
import { VaccineStatusEntity, vaccineStatusHierarchy } from './vaccineStatusHierarchy';

type State = {
    locations: null | LocationEntity[];
    causes: null | CauseEntity[];
    sequelas: null | SequelaEntity[];
    risks: null | ReiEntity[];
    etiologies: null | ReiEntity[];
    impairments: null | ReiEntity[];
    injuries: null | ReiEntity[];
    sevs: null | ReiEntity[];
    vehss: null | CauseEntity[];
    cros: null | CroEntity[];
    causeICDCodes: null | CauseICDCodeEntity[];
    vaccinationStatuses: null | VaccineStatusEntity[];
    races: null | RaceEntity[];
};

const initialState: State = {
    locations: null,
    causes: null,
    sequelas: null,
    risks: null,
    etiologies: null,
    impairments: null,
    injuries: null,
    sevs: null,
    vehss: null,
    cros: null,
    causeICDCodes: null,
    vaccinationStatuses: vaccineStatusHierarchy,
    races: null,
};

export default combineReducers<State>({
    locations: createReducer(initialState.locations).handleAction(
        getLocationsAsync.success,
        (state, action) => action.payload
    ),
    causes: createReducer(initialState.causes).handleAction(
        getCausesAsync.success,
        (state, action) => action.payload
    ),
    causeICDCodes: createReducer(initialState.causeICDCodes).handleAction(
        getCauseIcdCodesAsync.success,
        (state, action) => action.payload
    ),
    sequelas: createReducer(initialState.sequelas).handleAction(
        getSequelasAsync.success,
        (state, action) => action.payload
    ),
    risks: createReducer(initialState.risks).handleAction(
        getRisksAsync.success,
        (state, action) => action.payload
    ),
    etiologies: createReducer(initialState.etiologies).handleAction(
        getEtiologiesAsync.success,
        (state, action) => action.payload
    ),
    impairments: createReducer(initialState.impairments).handleAction(
        getImpairmentsAsync.success,
        (state, action) => action.payload
    ),
    injuries: createReducer(initialState.injuries).handleAction(
        getInjuryAsync.success,
        (state, action) => action.payload
    ),
    sevs: createReducer(initialState.sevs).handleAction(
        getRisksAsync.success,
        (state, action) => action.payload
    ),
    vehss: createReducer(initialState.vehss).handleAction(
        getVehssAsync.success,
        (state, action) => action.payload
    ),
    cros: createReducer(initialState.cros).handleAction(
        getCrosAsync.success,
        (state, action) => action.payload
    ),
    vaccinationStatuses: createReducer(initialState.vaccinationStatuses),
    races: createReducer(initialState.races).handleAction(
        getRacesAsync.success,
        (state, action) => action.payload
    ),
});
